/**
 * Dark theme aligned with the mobile app (ChurchApp ThemeContext).
 * All values are injected as CSS variables (--key) on document.documentElement.
 */
export const colors = {
  // Primary brand (warm neutrals from mobile)
  primary: '#d7c4ad',
  primaryDark: '#a58368',
  onPrimary: '#000000',
  accent: '#00BCD4',
  white: '#FFFFFF',

  // Text and backgrounds (existing var names for compatibility)
  text: '#FFFFFF',
  muted: '#B0BEC5',
  bg: '#121212',
  footer: '#121212',
  navInactive: '#B0B0B0',

  // Surfaces and on-colors (surface = card background, distinct from page/nav)
  surface: '#2A2A2A',
  surfaceVariant: '#1E1E1E',
  onSurface: '#FFFFFF',
  onSurfaceVariant: '#B0BEC5',
  background: '#121212',
  onBackground: '#FFFFFF',

  // Semantic
  error: '#CF6679',
  onError: '#000000',
  errorContainer: '#B00020',
  onErrorContainer: '#FECDD3',
  success: '#4CAF50',
  successContainer: '#1B3D1F',
  onSuccessContainer: '#A8D5AB',
  warning: '#FF9800',
  warningContainer: '#3D2E00',
  onWarningContainer: '#FFE0B2',
  info: '#2196F3',

  // Borders and outline
  outline: '#37474F',
  outlineVariant: '#263238',

  // Elevation (flat keys for CSS variable injection)
  elevation1: '#1A1A1A',
  elevation2: '#222222',
  elevation3: '#2A2A2A',
  elevation4: '#323232',
  elevation5: '#3A3A3A',

  // Optional mobile palette (for future use)
  inverseSurface: '#F5F5F5',
  inverseOnSurface: '#121212',
  inversePrimary: '#00695C',
  secondary: '#80DEEA',
  tertiary: '#4FD1C7',
} as const;

export type ColorKey = keyof typeof colors;

export const injectCssVariables = () => {
  if (typeof document === 'undefined') return; // safeguard for SSR/tests
  Object.entries(colors).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--${key}`, value as string);
  });
};
